<template>
  <v-sheet class="mx-auto mt-4 pa-4" elevation="2" outlined>
    <h4 class="mb-3">
      <v-icon class="mr-2" color="primary">mdi-robot-outline</v-icon>
      Inteligência de E-mail
    </h4>

    <v-checkbox
      label="Classificar emails recebidos com IA"
      v-model="localConfig.classify_inbound_email.enabled"
      hide-details
      class="mt-0"
      @change="emitUpdate"
    ></v-checkbox>

    <v-row v-if="localConfig.classify_inbound_email.enabled" class="mt-2">
      <v-col cols="12" md="6" class="py-0">
        <v-select
          dense
          outlined
          label="Modo de finalização"
          v-model="localConfig.classify_inbound_email.finalization_mode"
          :items="finalizationModes"
          item-text="label"
          item-value="value"
          @change="emitUpdate"
        ></v-select>
      </v-col>
      <!-- <v-col cols="12" md="6" class="py-0">
        <v-text-field
          dense
          outlined
          type="number"
          min="0"
          max="1"
          step="0.05"
          label="Limiar de confiança"
          v-model.number="localConfig.classify_inbound_email.confidence_threshold"
          @input="emitUpdate"
        ></v-text-field>
      </v-col> -->
    </v-row>

    <!-- <v-divider class="my-4"></v-divider>

    <v-checkbox
      label="Criar solicitação a partir de qualquer email (em breve)"
      v-model="localConfig.create_from_any_email.enabled"
      disabled
      hide-details
    ></v-checkbox>
    <p class="caption grey--text mt-1 mb-0">
      Identificadores para criação automática de solicitações serão configuráveis em versão futura.
    </p> -->
  </v-sheet>
</template>

<script>
const defaultConfig = () => ({
  classify_inbound_email: {
    enabled: false,
    finalization_mode: "prefill",
    confidence_threshold: 0.85,
  },
  create_from_any_email: {
    enabled: false,
    identifiers: [],
  },
});

export default {
  name: "SolicitationTypeAiEmailComponent",
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      localConfig: defaultConfig(),
      syncingFromParent: false,
      finalizationModes: [
        { label: "Pré-preencher interação", value: "prefill" },
        { label: "Finalizar automaticamente", value: "auto" },
      ],
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.syncingFromParent = true;
        this.localConfig = this.mergeConfig(newValue);
        this.$nextTick(() => {
          this.syncingFromParent = false;
        });
      },
    },
  },
  methods: {
    mergeConfig(value) {
      const base = defaultConfig();
      if (!value) return base;

      if (typeof value === "string") {
        try {
          value = JSON.parse(value);
        } catch (error) {
          return base;
        }
      }

      return {
        classify_inbound_email: {
          ...base.classify_inbound_email,
          ...(value.classify_inbound_email || {}),
        },
        create_from_any_email: {
          ...base.create_from_any_email,
          ...(value.create_from_any_email || {}),
        },
      };
    },

    getConfig() {
      return JSON.parse(JSON.stringify(this.localConfig));
    },

    emitUpdate() {
      if (this.syncingFromParent) return;
      this.$emit("input", this.getConfig());
    },
  },
};
</script>
